export default __webpack_public_path__ + "static/media/content.4eab0197.svg";